'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	(0, _jquery2.default)("div[" + DATA_ATTR + "]", this).each(function () {
		var _this = this;

		var wrapper = this;
		var options = JSON.parse((0, _jquery2.default)(this).attr(DATA_ATTR));

		(0, _jquery2.default)(this).removeAttr(DATA_ATTR);

		// backward compatible code
		if ((0, _jquery2.default)(this).attr('data-single-file')) {
			options.singleFile = true;
		}
		if ((0, _jquery2.default)(this).attr('data-images-only')) {
			options.imagesOnly = true;
		}
		// end - backward compatible code


		var addHiddenInput = function addHiddenInput(file) {
			(0, _jquery2.default)('<input>').attr({
				type: 'hidden',
				id: options.inputName + '[' + file.guid + ']',
				name: options.inputName + '[' + file.guid + ']',
				value: file.name
			}).appendTo(wrapper);
		};

		var setSubmitDisabled = function setSubmitDisabled(disabled) {
			if (!options.allowSubmitWhileUploading) {
				var button = (0, _jquery2.default)(_this).closest('form').find(':submit');
				if (button.length > 0) {
					button.attr("disabled", disabled);
				}
			}
		};

		(0, _jquery2.default)(this).addClass("dropzone");

		var dropzoneOptions = {
			paramName: 'files',
			previewTemplate: options.imagesOnly === true ? templateImg() : templateFile(),
			url: options.url,
			dictDefaultMessage: Resx.DropZone.Message,
			clickable: true,
			enqueueForUpload: true,
			maxFilesize: 20,
			acceptedFiles: options.acceptedFiles || (options.imagesOnly === true ? ".png,.jpg,.jpeg,.gif" : _dropzone2.default.options.acceptedFiles || ""),
			uploadMultiple: false,
			addRemoveLinks: false,
			sending: function sending(f, xhr) {
				return (0, _ajax.addCsrfToken)(xhr);
			},
			removedfile: function removedfile(file) {
				var _ref = void 0;
				(0, _jquery2.default)(wrapper).find('input[value="' + file.name + '"]').remove();
				delete tempFileCache[file.guid];
				return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
			},

			init: function init() {

				if (options.singleFile) this.hiddenFileInput.removeAttribute('multiple');

				this.on("maxfilesexceeded", function (file) {
					this.removeAllFiles();
					if (this.options.maxFiles === 0) this.options.maxFiles = 1;
					this.addFile(file);
				});

				this.on("sending", function (data) {
					setSubmitDisabled(true);
				});

				this.on("complete", function (data) {
					setSubmitDisabled(false);
				});

				this.on("success", function (file) {
					var res = JSON.parse(file.xhr.responseText);
					file.guid = res.result.guid;

					tempFileCache[file.guid] = file; // cache file

					addHiddenInput(file);
				});

				this.on("error", function (data) {
					log('dropzone upload failed %o', data);
				});

				this.on("addedfile", function (file) {
					// remove download and copy URL to clipboard from temp files
					(0, _jquery2.default)(file.previewElement).find("[data-dz-action-download]").remove();
					(0, _jquery2.default)(file.previewElement).find("[data-dz-action-clipboard]").remove();

					// if single file enabled, remove first file if more than one
					if (options.singleFile && this.files[1] != null) {
						this.removeFile(this.files[0]);
					}
				});
			}
		};

		var thisDropzone = (0, _jquery2.default)(this).dropzone(dropzoneOptions);

		var dz = thisDropzone[0].dropzone;
		var persistedFiles = options.files || [];
		var tempFiles = (0, _keys2.default)(options.tempFiles || {}).map(function (guid) {
			return tempFileCache[guid];
		});
		var count = persistedFiles.length + tempFiles.length;
		var addInitialFile = function addInitialFile(file, isTemp) {
			dz.files.push(file);
			dz.options.addedfile.call(dz, file);
			dz.options.complete.call(dz, file);
			dz.options.success.call(dz, file);
			dz.options.thumbnail.call(dz, file, file.thumbnailUrl);

			var $previewElement = (0, _jquery2.default)(file.previewElement);
			$previewElement.attr('data-dz-guid', file.guid);
			if (isTemp) {
				$previewElement.find("[data-dz-action-download]").remove();
				$previewElement.find("[data-dz-action-clipboard]").remove();
				addHiddenInput(file);
			} else {
				$previewElement.attr('data-dz-download-url', file.url);
				$previewElement.find('[data-dz-action-clipboard]').attr("data-dz-action-clipboard", file.url);
				$previewElement.find('[data-dz-action-download]').attr("href", file.url);
			}
		};
		persistedFiles.forEach(function (file) {
			return addInitialFile(file, false);
		});
		tempFiles.forEach(function (file) {
			return addInitialFile(file, true);
		});

		if (dzClipboard != null) {
			dzClipboard.destroy();
		}
		dzClipboard = new _clipboard2.default("[data-dz-action-clipboard]", {
			text: function text(trigger) {
				_notify2.default.success(Resx.DropZone('CopiedToClipboard')); // Zkopírováno do schránky.
				return (0, _jquery2.default)(trigger).attr("data-dz-action-clipboard");
			}
		});

		if (options.singleFile === true && count > 0) dz.options.maxFiles = 0;else if (options.singleFile === true) dz.options.maxFiles = 1;
	});
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('../core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _dropzone = require('dropzone');

var _dropzone2 = _interopRequireDefault(_dropzone);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _notify = require('../notify');

var _notify2 = _interopRequireDefault(_notify);

var _ajax = require('../utils/ajax');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DropZone initializer
 * Usage:
 * <div data-dropzone="{ ...options }" data-single-file="true"></div>
 *
 * Options:
 * uploadUrl <string>
 * variableName <string>
 */

var log = (0, _debug2.default)('linksoft:dropzone');

_dropzone2.default.autoDiscover = false;
var Resx = (0, _localize2.default)('DropZone');
var DATA_ATTR = 'data-dropzone';
var dzClipboard = null;

var tempFileCache = {};

var templateFile = function templateFile() {
	return '\n<div class="dropzpone-file">\n    <div class="title">\n        <span data-dz-name></span> <small class="pull-right"><span data-dz-size></span></small>\n    </div>\n    <div class="icons">\n        <a data-dz-action-download target="_blank">\n            <i class="fa fa-download blue"  data-toggle="tooltip" data-original-title="' + Resx.DropZone.Download + '"></i>\n        </a>\n        <i class="fa fa-clipboard" data-toggle="tooltip" data-original-title="' + Resx.DropZone.CopyToClipboard + '" data-dz-action-clipboard></i>\n        <i data-dz-remove class="fa fa-remove red" data-toggle="tooltip" data-original-title="' + Resx.DropZone.Delete + '"></i>\n    </div>\n</div>';
};

var templateImg = function templateImg() {
	return '\n<div class="dropzpone-image">\n    <img data-dz-thumbnail />\n    <div class="title">\n        <span data-dz-name></span>\n    </div>\n    <div class="size">\n        <small><span data-dz-size></span></small>\n    </div>\n    <div class="icons">\n        <a data-dz-action-download target="_blank">\n            <i class="fa fa-download blue"  data-toggle="tooltip" data-original-title="' + Resx.DropZone.Download + '"></i>\n        </a>\n        <i class="fa fa-clipboard" data-toggle="tooltip" data-original-title="' + Resx.DropZone.CopyToClipboard + '" data-dz-action-clipboard></i>\n        <i data-dz-remove class="fa fa-remove red" data-toggle="tooltip" data-original-title="' + Resx.DropZone.Delete + '"></i>\n    </div>\n    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n</div>';
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/dropzone.js
// module id = 497
// module chunks = 0